import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './BloodSugarRecord.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import Modal from '../../../../../components/comm/Modal';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';
import URL from '../../../../../constants/url';
import BloodSugarRecordBox from '../../../../../components/box/BloodSugarRecordBox';
import LineGraphBox from '../../../../../components/box/LineGraphBox';


import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import { useNavigate, useLocation } from 'react-router-dom';
import ConfirmBox from '../../../../../components/box/ConfirmBox';

import Skeleton from '@mui/material/Skeleton';

const BloodSugarRecord = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [recordList, setRecordList] = useState([]);

    const [fastingRecords, setFastingRecords] = useState([]);  //공복
    const [afterMealRecords, setAfterMealRecords] = useState([]); //식후

    const [isOpen, setIsOpen] = useState(false);    //모달창
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [toast, setToast] = useState(false); //토스트 팝업
    const [toastMessage, setToastMessage] = useState('');

    const [visibleCount, setVisibleCount] = useState(10); // 리스트 갯수
    const [isLoading, setIsLoading] = useState(false); // 스크롤 딜레이 중인지

    const [isInitialLoading, setIsInitialLoading] = useState(true); // 초기 로딩 상태


    const confirmDelete = (index) => {
        setDeleteIndex(index);
        setIsOpen(true);
    };

    const handleConfirmDelete = (chooseAt) => {

        if (chooseAt) {
            if (deleteIndex !== null) {
                handleDelete(deleteIndex);
                setDeleteIndex(null);
            }
            setIsOpen(false);
        } else {
            setIsOpen(false);
        }
    };

    //날짜 변환
    const parseDateTime = (dateStr, timeStr) => {
        // 예: dateStr = "20250703", timeStr = "100700"
        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10) - 1; // 0-based
        const day = parseInt(dateStr.substring(6, 8), 10);

        const hour = parseInt(timeStr.substring(0, 2), 10);
        const minute = parseInt(timeStr.substring(2, 4), 10);
        const second = parseInt(timeStr.substring(4, 6), 10);

        return new Date(year, month, day, hour, minute, second);
    };

    //그래프 전용 데이터
    const updateGraphData = (records) => {
        if (!records || records.length === 0) return;

        const parseAndSort = (status) => {
            return [...records]
                .filter((r) => r.bdsgSeCd === status)
                .sort((a, b) => parseDateTime(a.recDe, a.recTm) - parseDateTime(b.recDe, b.recTm))
                .slice(-3); // 최근 3개만 (오름차순 정렬이므로 뒤에서 자르기)
        };

        const fasting = parseAndSort("1");
        const afterMeal = parseAndSort("2");

        setFastingRecords(fasting);
        setAfterMealRecords(afterMeal);

    };

    //삭제
    const handleDelete = (index) => {
        setUsrBdsgHist(index);
    };
    const setUsrBdsgHist = useCallback(async (index) => {
        const record = recordList[index];
        if (!record || !record.usrBdsgHistId) return;

        const url = "/homecare/bdsg/deleteBloodSugarRecordHistory";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };

        const reqBody = {
            usrBdsgHistId: record.usrBdsgHistId
        };

        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setToastMessage('기록이 삭제되었습니다.');
                setToast(true); // 삭제 후 토스트
                getUsrBdsgHist(); // 리스트 새로고침
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("혈압 기록 삭제 중 오류: ", err);
        }
    }, [recordList, navigate]);

    //시간 변환 (시간, 날짜)
    const convertTimeStr = (timeStr) => {
        const hour = timeStr.substring(0, 2);
        const minute = timeStr.substring(2, 4);
        return `${hour}:${minute}`;
    };
    const formatDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(2, 4);  // 2025 -> 25
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };

    // 최신 날짜용 (연도 4자리)
    const formatLatestDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(0, 4);  // 25 -> 2025
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };

    
    //데이터 불러오기
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            getUsrBdsgHist();
            return;
        }
    }, []);
    const updateList = (records) => {
        const sortedByLatest = [...records].sort((a, b) => {
            const dateA = parseDateTime(a.recDe, a.recTm);
            const dateB = parseDateTime(b.recDe, b.recTm);
            return dateB - dateA;
        });
        setRecordList(sortedByLatest);
    }
    const getUsrBdsgHist = useCallback(async () => {
        const url = "/homecare/bdsg/retrieveBloodSugarRecordHistory";

        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        console.log("========> usrInfoId: ", loginUser.usrInfoId);
        const reqBody = {
            usrInfoId: loginUser.usrInfoId
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const recList = res.data.result.recList;

                setRecordList(recList);
                updateGraphData(recList);
                updateList(recList);
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("혈당 기록 조회 중 오류: ", err);
        } finally {
            setIsInitialLoading(false); // 로딩 완료
        }

    }, [navigate,recordList]);



    useEffect(() => {
        if (location.state?.showToast) {
        setToastMessage(location.state.toastMessage);
        setToast(true);

        // 토스트 띄운 후에 state 초기화 (덮어쓰기)
        navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate]);

    //뒤로 가기
    const handleBack = () => {
        navigate(URL.HOME_CARE_MAIN, {
            replace: true,
            state: { tabIndex: 1 }
        });
    };


    const loadMore = () => {
        if (isLoading) return; // 이미 로딩 중이면 무시
        setIsLoading(true);

        setTimeout(() => {
            setVisibleCount(prev => Math.min(prev + 10, recordList.length));
            setIsLoading(false);
        }, 300); // 300ms 딜레이
    };

    //무한 스크롤
    const observerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            },
            { threshold: 1 }
        );

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [recordList, visibleCount]);

    // 스켈레톤 컴포넌트
    const SkeletonLoader = () => (
        <>
            {/* 그래프 스켈레톤 */}
            <div className={style['graph-box']}>
                <div className={style['graph-top']}>
                    <Skeleton variant="text" width={150} height={24} />
                    <Skeleton variant="text" width={80} height={24} />
                </div>
                <div className={style['graph-bot']}>
                    <div className={style['inner-box']}>
                        <Skeleton variant="rectangular" width="100%" height={140} style={{borderRadius:'12px'}} />
                    </div>
                </div>
            </div>

            {/* 리스트 스켈레톤 */}
            <div className="inner-wrap">
                <div className={style['record-box-lists']}>
                    <ul>
                        {[...Array(3)].map((_, idx) => (
                            <li key={idx} style={{ width:"100%", height:'120px', padding:'16px', marginBottom: '12px', backgroundColor:'#fff', borderRadius:'12px'}}>
                                 <Skeleton variant="text" width={80} height={24} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={'80%'} height={20} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={'60%'} height={20} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={120} height={22} style={{ borderRadius:'4px', marginBottom:'6px'}} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );


    return (
        <>

            <HeadSub title="혈당 기록" rightBtn="yes" rightTitle="혈당기록 가이드" recordNum="3" onBack={handleBack}/>  {/* recordNum="1" 혈압 , 2 = 체질량 , 3 = 혈당 */}


            <div id="sub-content">

                {isInitialLoading ? (
                    <SkeletonLoader />
                ) : recordList.length === 0 ? (
                    <div className='animation-3'>
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}>
                                <object data={noDataImg} aria-hidden='true'></object>
                            </div>
                            <p>기록이 없습니다.</p>
                        </div>
                    </div>
                ):
                <>
                    <div className={style['graph-box']}>
                        <div className={style['graph-top']}>
                            <p>{formatLatestDateStr(recordList[0].recDe)} {convertTimeStr(recordList[0].recTm)}</p>  {/* 가장 최신 등록일자 노출 */}
                            <ul className={style['legend-box']}>
                                <li data-status="1">
                                    <p>공복</p>
                                    <span>
                                        {recordList
                                            .filter(r => r.bdsgSeCd === "1")
                                            .sort((a, b) => parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm))[0]?.bdsgVal || '-'}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className={style['graph-bot-wrap']}>

                            {/* 공복 그래프 */}

                            {fastingRecords.length > 0 && (
                                <div className={style['graph-bot']}>
                                    <div className={style['inner-box']}>
                                        <ul className={style['line-graph-box']}>
                                            <li>
                                                <LineGraphBox
                                                    data={{
                                                        columns: [fastingRecords.map((r) => r.bdsgVal)]
                                                    }}
                                                    graphColor={[
                                                    "#3284FF"
                                                    ]}
                                                    height={10}
                                                />
                                            </li>
                                        </ul>

                                        <div className={style['line-graph-date-box']}>
                                            <ul data-graph-length={fastingRecords.length === 2 ? "twin" : ""}>
                                                {fastingRecords.map((r, i) => (
                                                    <li key={i}>
                                                        <div className={style['date-text']}>
                                                            <p>{formatDateStr(r.recDe)}</p>
                                                            <span>{convertTimeStr(r.recTm)}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </div>


                        <div className={style['graph-bot-wrap']}>
                            {/* 식후 그래프 */}
                            {afterMealRecords.length > 0  && (
                                <>
                                <div className={style['graph-top']} data-align="right">
                                    <ul className={style['legend-box']}>
                                        <li data-status="2">
                                            <p>식후</p>
                                            <span>
                                                {recordList
                                                .filter(r => r.bdsgSeCd === "2")
                                                .sort((a, b) => parseDateTime(b.recDe, b.recTm) - parseDateTime(a.recDe, a.recTm))[0]?.bdsgVal || '-'}
                                            </span>
                                        </li>
                                    </ul>
                                </div>    

                                <div className={style['graph-bot']}>
                                    <div className={style['inner-box']}>
                                        <ul className={style['line-graph-box']}>
                                            <li>
                                                <LineGraphBox
                                                    data={{
                                                        columns: [afterMealRecords.map((r) => r.bdsgVal)]
                                                    }}
                                                    graphColor={[
                                                    "#00A1A9"
                                                    ]}
                                                    height={10}
                                                />
                                            </li>
                                        </ul>

                                        <div className={style['line-graph-date-box']}>
                                            <ul data-graph-length={afterMealRecords.length === 2 ? "twin" : ""}>
                                                {afterMealRecords.map((r, i) => (
                                                    <li key={i}>
                                                        <div className={style['date-text']}>
                                                            <p>{formatDateStr(r.recDe)}</p>
                                                            <span>{convertTimeStr(r.recTm)}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                </>
                            )}

                        </div>
                </div>

                <div className="inner-wrap">
                    <div className={style['record-box-lists']}>
                        <ul>
                            {recordList.slice(0, visibleCount).map((item, idx) => (
                                <li key={idx}>
                                    <BloodSugarRecordBox
                                        measureStatus={item.bdsgSeCd === "1" ? "공복" : "식후"}
                                        statusValue={item.bdsgSeCd}
                                        bloodSugar={item.bdsgVal}
                                        date={formatDateStr(item.recDe)}
                                        time={convertTimeStr(item.recTm)}
                                        onDelete={() => confirmDelete(idx)}
                                        status={item.rsltCd}
                                    />
                                </li>
                            ))}
                        </ul>
                        {visibleCount < recordList.length && (
                            <div ref={observerRef} style={{ height: '1px' }} />
                        )}
                    </div>
                </div>
                </>
            }

            {/* 하단 다음 버튼 영역 :: S */}
                <div className="bottom-fixed-box">
                        <div className="inner-box" data-bg-color="transparent">

                                {/* 버튼이 1개일때     */}
                            <div className='btn-layout' data-btn-num="1">
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> navigate(URL.BLOOD_SUGAR_WRITE)}>
                                    <span>혈당 기록하기</span>
                                </button>
                            </div>

                        </div>
                </div>
            {/* 하단 다음 버튼 영역 :: E */}


            </div>

            <ConfirmBox isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onCloseCallback={handleConfirmDelete}
                        message={'기록을 삭제하시겠어요?'}
                        leftBtnTxt={'아니오'}
                        rightBtnTxt={'네'} />

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default BloodSugarRecord;
